import { Content } from "antd/lib/layout/layout";
import { ReactElement } from "react";
import { Outlet } from "react-router-dom";
import s from "./AppContent.module.scss";

export function AppContent(): ReactElement {
  return (
    <Content className={s.container}>
      <Outlet />
    </Content>
  );
}
